export const setButtonLoadingState = (button, isLoading) => {
  button.setAttribute('data-loading', isLoading ? 'true' : 'false')
}
